<template>
  <v-card class="card" width="100%">
    <v-card-title>Conteo de Ingresos a la Plataforma</v-card-title>
    <v-card-text class="pa-3">
      <!-- <line-chart
        :data="data"
        xtitle="Tiempo"
        ytitle="Usuarios Nuevos"
        :dataset="{borderWidth: 3}"
        :curve="false"
        title="Estadística de Usuarios"
      /> -->
      <LineChart
        :chart-data="data"
        :options="chartOptions"
        :width="20"
        :height="10"
      ></LineChart>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    LineChart: () => import("@/components/generic/LineChart")
  },
  data() {
    return {
      data: {
        datasets: [
          {
            label: "Ingreso de Usuarios",
            data: [],
            fill: true,
            borderColor: "#3F51B5",
            pointBorderWidth: "2",
            lineTension: 0
          }
        ],
        labels: []
      },
      ingresoData: [],
      chartOptions: {
        scales: {
          xAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "Semanas"
              }
            }
          ],
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "Cantidad"
              },
              ticks: {
                beginAtZero: true,
                min: 0,
                userCallback: function (label, index, labels) {
                  // when the floored value is the same as the value we have a whole number
                  if (Math.floor(label) === label) {
                    return label;
                  }
                }
              }
            }
          ]
        }
      }
    };
  },

  methods: {
    createSiteViewData() {
      let tempdata = { ...this.data };
      this.getEstadisticaNuevosIngresos.forEach((item, index) => {
        tempdata.datasets[0].data.push(item.count);
        tempdata.labels.push(
          new Date(item.year, 0, 7 * (item.week - 1) + 1).toLocaleDateString(
            "es-ES",
            {
              year: "numeric",
              month: "short",
              day: "numeric"
            }
          )
        );
      });
      this.data = tempdata;
    },
    ...mapActions("admin", ["fetchEstadisticaNuevosRegistro"])
  },

  computed: {
    linechartData() {
      return {
        datasets: this.getEstadisticaNuevosIngresos
      };
    },
    ...mapGetters("admin", ["getEstadisticaNuevosIngresos"])
  },

  async mounted() {
    await this.fetchEstadisticaNuevosRegistro();
    this.createSiteViewData();
  }
};
</script>

<style>
.card {
  border-radius: 3px;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.21);
  background-color: transparent;
}
</style>
